import { apiService } from "../api.service";

// Domain Models
import { Permission } from "../../models/app/domain";

/**
 * Fetch Permissions Request
 * @return - PermissionsResponse || ErrorResponse
 */
export const fetchPermissionsRequest = async queryParams => {
  let query = "";
  queryParams.forEach(
    (param, i) => (query += `${i === 0 ? "?" : "&"}assignable_to=${param}`)
  );
  const response = await apiService.get(`/permissions${query}`);
  if (response.hasError) {
    return response;
  }
  return {
    permissions: response.data.permissions.map(
      permission => new Permission(permission)
    )
  };
};
